export function numberInStupidFormat(n: number): [number, number] {
    const asString = n.toString().padStart(2, '0');

    // Zuerst: Zehner, dann Einer
    const result: [number, number] = [Number(asString.charAt(0)), Number(asString.charAt(1))];

    return result;

}
